import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { request } from 'utilities/graph';
import { updateRecurringOrder } from 'graphql/mutations';
import { Semaphore } from 'async-mutex';
import { toastr } from 'react-redux-toastr';

export default function DisableRecurringOrderButton({
  onUpdate,
  rulesSelected,
  onResetRecurringOrder,
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    const rulesActive = rulesSelected.current.filter((rule) => rule.status === '使用中');
    const toUpdateData = [];
    const s = new Semaphore(1);

    await Promise.all(rulesActive.map((rule) =>
      s.runExclusive(async () => {
        const data = {
          id: rule.id,
          status: '已停用',
        };
        try {
          const { data: { updateRecurringOrder: updatedRecurringOrder } } = await request(updateRecurringOrder, { input: data });
          toUpdateData.push(data);
          if (onResetRecurringOrder) {
            await onResetRecurringOrder(updatedRecurringOrder);
          }
        } catch (e) {
          console.log(e);
          if (e.errors && e.errors[0] && e.errors[0].message) {
            toastr.error(e.errors[0].message);
          }
        }
      }),
    ));

    onUpdate && onUpdate(toUpdateData);
    setIsLoading(false);
  };

  const onDisableRecurringRules = async () => {
    const rulesActive = rulesSelected.current.filter((rule) => rule.status === '使用中');

    if (rulesActive.length === 0) {
      toastr.error('選擇的週期性設定中沒有使用中的設定');
      return;
    }

    const message = `共 ${rulesActive.length} 筆使用中的週期性設定，確定要停用這 ${rulesActive.length} 筆設定？`;

    if (!window.confirm(message)) return;

    handleSubmit();
  };

  return (
    <Fragment>
      <Button
        style={ { marginLeft: 10 } }
        variant="contained"
        color="secondary"
        onClick={onDisableRecurringRules}
        disabled={isLoading}
      >
        {isLoading ? '停用中...' : '停用週期性設定'}
      </Button>
    </Fragment>
  );
}

DisableRecurringOrderButton.propTypes = {
  onUpdate: PropTypes.func,
  rulesSelected: PropTypes.object,
  onResetRecurringOrder: PropTypes.func,
};
